import { http } from '@pendo/http';

export function fetchGoals () {
    return http.get('/api/s/_SID_/goal').then((res) => res.data);
}

export function fetchGoal ({ id }) {
    return http.get(`/api/s/_SID_/goal/${id}`).then((res) => res.data);
}

export function updateGoal ({ goal }) {
    return http.put(`/api/s/_SID_/goal/${goal.id}`, goal).then((res) => res.data);
}

export function createGoal ({ goal }) {
    return http.post('/api/s/_SID_/goal', goal).then((res) => res.data);
}

export function deleteGoal ({ id }) {
    return http.delete(`/api/s/_SID_/goal/${id}`);
}
